module.exports = "https://and-static.ghzs.com/web/bbs-desktop/static/img/anli_Star_blue .1829c.png";